import { render, staticRenderFns } from "./MessageStartEvent.vue?vue&type=template&id=798bf628&scoped=true&"
import script from "./MessageStartEvent.vue?vue&type=script&lang=js&"
export * from "./MessageStartEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798bf628",
  null
  
)

export default component.exports